function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildComponentName } from '../utils';
var __vue_script__ = {
  name: buildComponentName('Switch'),
  $_veeValidate: {
    rejectsFalse: true,
    value: function value() {
      return this.innerChecked;
    }
  },
  model: {
    prop: 'checked'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-switch'
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['small', 'default', 'large', ''].indexOf(val) > -1;
      }
    },
    checked: {
      type: Boolean,
      default: false
    },
    checkedChildren: {
      type: String,
      default: ''
    },
    uncheckedChildren: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerChecked: false
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size,
          loading = this.loading,
          innerChecked = this.innerChecked,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_ref, "".concat(prefixCls, "-loading"), loading), _defineProperty(_ref, "".concat(prefixCls, "-checked"), innerChecked), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    },
    sTabIndex: function sTabIndex() {
      var tabindex = this.tabindex,
          disabled = this.disabled;
      return disabled ? '-1' : tabindex || 0;
    }
  },
  watch: {
    checked: function checked(nVal) {
      this.setChecked(nVal, false);
    }
  },
  created: function created() {
    this.setChecked(this.checked, false);
  },
  mounted: function mounted() {
    var autofocus = this.autofocus,
        disabled = this.disabled,
        focus = this.focus;

    if (autofocus && !disabled) {
      focus();
    }
  },
  methods: {
    focus: function focus() {
      var switchRef = this.$refs.switchRef;

      if (switchRef) {
        switchRef.focus();
      }
    },
    blur: function blur() {
      var switchRef = this.$refs.switchRef;

      if (switchRef) {
        switchRef.blur();
      }
    },
    setChecked: function setChecked(checked) {
      var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var disabled = this.disabled;

      if (!disabled || disabled && !flag) {
        this.innerChecked = !!checked;
      }

      if (flag) {
        // support v-model
        this.$emit('input', this.innerChecked);
        this.$emit('change', this.innerChecked);
      }
    },
    onClick: function onClick() {
      var control = this.control,
          innerChecked = this.innerChecked;
      var checked = !innerChecked;

      if (!control) {
        this.setChecked(checked);
      }

      this.$emit('click', checked);
    },
    onMouseup: function onMouseup(e) {
      var blur = this.blur;
      blur();
      this.$emit('mouseup', e);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    ref: "switchRef",
    class: _vm.classes,
    attrs: {
      "tabindex": _vm.sTabIndex
    },
    on: {
      "click": _vm.onClick,
      "mouseup": _vm.onMouseup
    }
  }, [_c('span', {
    class: _vm.prefixCls + "-inner"
  }, [_vm.innerChecked ? _vm._t("checkedChildren", [_vm._v(" " + _vm._s(_vm.checkedChildren) + " ")]) : _vm._t("uncheckedChildren", [_vm._v(" " + _vm._s(_vm.uncheckedChildren) + " ")])], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "switch.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;